import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';

/** Tenant (reservoir) scope: resolves the slug against the tenants the user may access. */
export const Route = createFileRoute('/_authed/t/$tenantSlug')({
  beforeLoad: ({ context, params }) => {
    const tenant = context.me.tenants.find((t) => t.slug === params.tenantSlug);
    if (!tenant) throw notFound();
    return { tenant };
  },
  component: Outlet,
});
